"use client";
import ImageCommon from "@/src/component/image/image";
import { notFound } from "next/navigation";
import { Row, Col, Collapse, Button } from "antd";
import "../area/style.scss";
import Image from "next/image";
import tickIcon from "@/public/icon/tick-icon.svg";
import promotionTagIcon from "@/public/icon/promotion-tag-icon.svg";
import iconStar from "@/public/icon/icon-start-3d.svg";
import BreadcrumbCustom from "@/src/component/detail/breadcrumb";
import iconArrow from "@/public/icon/ChevronDownWhite.svg";
import chevronDown from "@/public/icon/chevron-down.png";
import Link from "next/link";
import { convertToMillionRange } from "@/src/util/util";
import useWindowSize from "@/src/hooks/useWindowSize";
import { useEffect, useState } from "react";
import FormChatBotMobile from "@/src/component/dialog/form-chat-bot-mobile";
import { Modal } from "antd";
import Chatbox from "@/src/component/detail/chatbox";
import { Empty } from "antd";
import { DateTime } from "luxon";

const { Panel } = Collapse;

const SharedUIClient = ({ result, dataArea }) => {
  const { data, ldp_data, district_has_ldp } = result;
  if (!data || !ldp_data || district_has_ldp || !dataArea) notFound;

  const hasDistrict = dataArea.district;
  const faq = JSON.parse(ldp_data?.faq);

  const { width } = useWindowSize();
  const [expanded, setExpanded] = useState(false);
  const [openBooking, setOpenBooking] = useState(false);
  const [openContact, setOpenContact] = useState(false);
  const [clinicDetail, setClinicDetail] = useState(null);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const width = window.innerWidth;
    setIsMobile(width < 768);
  }, [width]);

  const items = [
    { label: "Trang Chủ", href: "/" },
    { label: "Phòng khám", href: "/phong-kham" },
    {
      label: dataArea.province.name,
      href: `/phong-kham/${dataArea.province.slug}`,
    },
    hasDistrict
      ? {
          label: dataArea.district.name,
          href: `/phong-kham/${dataArea.province.slug}/${dataArea.district.slug}`,
        }
      : null,
  ].filter(Boolean);

  const getSortedServices = (clinic) => {
    const prioritizedServices = [
      "Niềng răng",
      "Trồng răng Implant",
      "Bọc răng sứ",
      "Nhổ răng khôn",
      "Răng giả tháo lắp",
      "Trám răng",
    ];

    let newArrPriority = [];
    let newArrNotPriority = [];

    clinic.service.forEach((curr) => {
      if (curr.service.length > 0) {
        const serviceName = curr.category_service.name;
        const priorityIndex = prioritizedServices.indexOf(serviceName);
        if (priorityIndex !== -1) {
          newArrPriority[priorityIndex] = curr;
        } else {
          newArrNotPriority.push(curr);
        }
      }
    });
    return [...newArrPriority.filter(Boolean), ...newArrNotPriority];
  };

  const currentMonthYear = DateTime.now().toFormat("MM/yyyy");
  return (
    <>
      <div className="wp-location-province">
        <BreadcrumbCustom items={items} />
        <h1>
          Nha khoa uy tín tại {hasDistrict ? `${dataArea.district.name}, ` : ""}
          {dataArea.province.name} - {currentMonthYear}
        </h1>
        <div className="wp-loadmore">
          <p
            className={`description ${expanded ? "expanded" : ""}`}
            dangerouslySetInnerHTML={{ __html: ldp_data.content }}
          />
          {isMobile && (
            <Button
              className="btn-loadmore"
              type="link"
              onClick={() => setExpanded((prev) => !prev)}
              icon={
                <Image
                  src={chevronDown}
                  width={13}
                  height={13}
                  style={{
                    transform: `rotate(${expanded ? -90 : 90}deg)`,
                    transition: "transform 0.3s ease",
                    display: "flex",
                  }}
                />
              }
              iconPosition="end"
            >
              {expanded ? "Thu gọn" : "Xem thêm"}
            </Button>
          )}
        </div>
        <div className="wp-clinic">
          {data.map((clinic) => {
            const avatar = clinic.image.find(
              (subItem) => subItem.image_type === "AVATAR"
            );
            const sortedServices = getSortedServices(clinic);
            return (
              sortedServices.length > 0 && (
                <Row
                  gutter={isMobile ? [0, 15] : [22, 22]}
                  className="clinic-card"
                >
                  <Col xs={24} lg={12}>
                    <div className="clinic-card__left">
                      <Link href={`/phong-kham/${clinic.slug}`}>
                        <ImageCommon data={avatar} style="clinic-card__logo" />
                      </Link>
                      <div>
                        <div className="clinic-card__meta">
                          <Link href={`/phong-kham/${clinic.slug}`}>
                            <h2 className="clinic-card__title">
                              {clinic.name}
                            </h2>
                          </Link>

                          <p className="clinic-card__address">
                            {clinic.address[0]}
                          </p>
                          <div className="wpRatingLine">
                            {clinic?.rating_overview?.overall_average ? (
                              <div className="wpRatingInLine">
                                <div className="ratingPoint">
                                  <div className="point">
                                    {clinic?.rating_overview?.overall_average.toFixed(
                                      1
                                    )}
                                  </div>
                                  <Image
                                    className="iconRatingStar"
                                    src={iconStar}
                                    alt="icon"
                                  />
                                </div>
                                <div className="dash"></div>
                              </div>
                            ) : null}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div className="ratingQuantity">
                                {clinic?.rating_overview?.number_of_ratings}{" "}
                                Đánh giá
                              </div>
                              <div className="dash"></div>
                              <div className="numberOfConsultation">
                                {clinic?.total_contact
                                  ? clinic?.total_contact
                                  : 0}{" "}
                                Người đặt lịch
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {clinic?.promotion_text?.length > 0 &&
                      clinic?.promotion_text[0] && (
                        <div className="wpPromotionText">
                          {clinic?.promotion_text[0]
                            ?.split(/\s*[;]\s*/)
                            ?.map((item) => {
                              return (
                                <div className="promotionItem">
                                  <Image
                                    src={promotionTagIcon}
                                    alt="promotionTagIcon"
                                    width={16}
                                    height={16}
                                    className="promotionTagIcon"
                                  />
                                  {item}
                                </div>
                              );
                            })}
                        </div>
                      )}
                    {clinic?.tag_clinic?.length > 0 && (
                      <div className="wpUtilities">
                        {clinic.tag_clinic.map((tag) => (
                          <div className="utilitiesItem">
                            <Image
                              src={tickIcon}
                              alt="tickIcon"
                              width={14}
                              height={14}
                              className="tickIcon"
                            />
                            {tag?.tag?.name}
                          </div>
                        ))}
                      </div>
                    )}
                    <span
                      className="clinic-card__desc line-clamp"
                      dangerouslySetInnerHTML={{ __html: clinic.introduce }}
                    />
                  </Col>

                  <Col xs={24} lg={12} className="wp-clinic-right">
                    <Row
                      gutter={isMobile ? [16, 10] : [16, 16]}
                      className="clinic-card__services"
                    >
                      {(() => {
                        if (sortedServices.length > 0) {
                          return sortedServices
                            .slice(0, isMobile ? 4 : 8)
                            .map((item, index) => {
                              const minAmount = Math.min(
                                ...item.service.map((service) => service.amount)
                              );
                              const maxAmountMax = Math.max(
                                ...item.service.map(
                                  (service) => service.amount_max
                                )
                              );
                              return (
                                <Col xs={24} sm={12} key={index}>
                                  <Row className="service-item">
                                    <Col
                                      span={12}
                                      className="service-item__name"
                                    >
                                      {item.category_service.name}
                                    </Col>
                                    <Col
                                      span={12}
                                      className="service-item__price"
                                    >
                                      {convertToMillionRange(
                                        minAmount,
                                        maxAmountMax
                                      )}
                                    </Col>
                                  </Row>
                                </Col>
                              );
                            });
                        } else {
                          return (
                            <Empty
                              className="empty-service"
                              description={"Đang cập nhật bảng giá dịch vụ..."}
                            />
                          );
                        }
                      })()}
                    </Row>
                    <Row className="clinic-card__actions" gutter={8}>
                      <Col>
                        <Button
                          onClick={() => {
                            setClinicDetail(clinic);
                            setOpenContact(true);
                          }}
                          className="btn btn--primary"
                          type="primary"
                        >
                          Nhận tư vấn
                        </Button>
                      </Col>
                      <Col>
                        <Button
                          onClick={() => {
                            setClinicDetail(clinic);
                            setOpenBooking(true);
                          }}
                          className="btn btn--outline"
                          type="primary"
                        >
                          Đặt lịch giữ chỗ
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              )
            );
          })}
        </div>
        <div className="wp-faq">
          <h2>Câu hỏi thường gặp</h2>
          <Collapse
            accordion
            expandIconPosition="end"
            bordered={false}
            expandIcon={({ isActive }) => (
              <div
                style={{
                  transform: `rotateX(${isActive ? 0 : 180}deg)`,
                }}
              >
                <Image
                  src={iconArrow}
                  width={25}
                  height={25}
                  className="collapse-expand-icon"
                  alt="icon"
                />
              </div>
            )}
          >
            {faq?.map((item, index) => {
              const answer = "➤ " + item.answer.replace(/\n/g, "<br />");
              return (
                <Panel
                  header={
                    <>
                      <div className="wp-faq__index">{index + 1}</div>
                      <h3>{item.question}</h3>
                    </>
                  }
                  key={item.id}
                  style={{ border: "none", marginBottom: "16px" }}
                >
                  <p dangerouslySetInnerHTML={{ __html: answer }} />
                </Panel>
              );
            })}
          </Collapse>
        </div>
        {district_has_ldp.length > 0 && (
          <div className="wp-near-by-areas">
            <h2>THAM KHẢO CÁC KHU VỰC LÂN CẬN</h2>
            <Row gutter={isMobile ? [0, 15] : [50, 30]}>
              {district_has_ldp.map((item, index) => (
                <Col xs={24} md={12} lg={8} key={index}>
                  <Collapse
                    expandIconPosition={"end"}
                    expandIcon={({ isActive }) => (
                      <Button
                        type="link"
                        icon={
                          <Image
                            style={{
                              transform: `rotate(${isActive ? 90 : 0}deg)`,
                              transition: "transform 0.3s ease",
                            }}
                            src={chevronDown}
                            width={13}
                            alt="icon-select-double"
                          />
                        }
                        style={{ color: "#293568" }}
                      />
                    )}
                  >
                    <Collapse.Panel
                      key={item.district.slug}
                      collapsible="icon"
                      // showArrow={false}
                      header={
                        <Link
                          href={`/phong-kham/${dataArea.province.slug}/${item.district.slug}`}
                        >
                          <h3> Nha khoa tại {item.district.name}</h3>
                        </Link>
                      }
                    />
                  </Collapse>
                </Col>
              ))}
            </Row>
          </div>
        )}
      </div>
      <Modal
        className="wpModalChatBox"
        open={openBooking}
        footer={null}
        closable={true}
        width={380}
        centered
        style={{ top: 10 }}
        destroyOnClose={true}
        onCancel={() => {
          setOpenBooking(false);
        }}
      >
        <div style={{ position: "relative" }}>
          <Chatbox detailClinic={clinicDetail} isModal={true} />
        </div>
      </Modal>
      <Modal
        className="modal-chatbot-mobile"
        open={openContact}
        onCancel={() => {
          setOpenContact(false);
        }}
        footer={null}
        closable={true}
        width={380}
        destroyOnClose={true}
        centered
      >
        <FormChatBotMobile clinic={clinicDetail} />
      </Modal>
    </>
  );
};

export default SharedUIClient;
